import React, { Component } from 'react';

import TextField from '@material-ui/core/TextField';

class Search extends Component {
    state = {
        id: this.props.id || "search"
        , search: ""
        , label: this.props.label ? this.props.label : "Pesquisar"
    };

    handleFieldChange = (e) => {
        const value = e.target.value;
        if (value.length > 2 || value === "") {
            this.props.searchCallback(value);
        }
        this.setState({ search: value });
    }

    render() {
        const { search, label, id } = this.state;
        return (
            <div className={"searchHolder " + this.props.className} >
                <TextField 
                    id={id}
                    fullWidth={true}
                    value={search}
                    onChange={this.handleFieldChange}
                    label={label} />
            </div>
        );
    }
}

export default Search;
